import React from "react";
import "./StartCoursePopup.css";

const StartCoursePopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        {/* CLOSE BUTTON */}
        <span className="close-btn" onClick={onClose}>
          ×
        </span>

        <h2>Start Your Course</h2>
        <p className="subtitle">
          Fill the details and our team will contact you
        </p>

        <form className="popup-form">
          {/* ROW 1 */}
          <div className="form-row">
            <input type="text" placeholder="Course Name" />
            <input type="text" placeholder="Student Name" />
          </div>

          {/* ROW 2 */}
          <div className="form-row">
            <input type="email" placeholder="Email Address" />
            <input type="tel" placeholder="Phone Number" />
          </div>

          {/* ROW 3 */}
          <div className="form-row">
            <select>
              <option>Select Training Type</option>
              <option>Online</option>
              <option>Offline</option>
            </select>

            <select>
              <option>Current Profile</option>
              <option>Student</option>
              <option>Graduated</option>
              <option>Looking for a Career</option>
              <option>Career Change</option>
              <option>Looking to Upskill</option>
            </select>
          </div>

          {/* MESSAGE */}
          <textarea placeholder="Message" rows="3"></textarea>

          {/* BUTTON */}
          <button type="submit" className="submit-btn">
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default StartCoursePopup;
